export class SIQQueueBannerTheme {
  backgroundColor = "null";
  titleColor = "null";
  subtitleColor = "null";
  subtitleTimeColor = "null";
  positionTextColor = "null";
  positionSubtitleColor = "null";
  positionContainerBackgroundColor = "null";
}
//# sourceMappingURL=SIQQueueBannerTheme.js.map